export default "__VITE_ASSET__CBFO43nu__"